import * as React from 'react';
import { FC, PropsWithChildren, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { YoAuthUser } from '@yakoffice/yakoffice-firebase';
import { NavLink } from 'react-bootstrap';
import { mapPublisherProjectIdToProjectIdString } from './helpers';
import styles from './navigation-rail.module.sass';


export interface IamNavigationRailItemsPropsType {
    authUser: YoAuthUser;
    hostedInPortal: boolean;
    portalUrl: string;

}

export const IamNavigationRailItems: FC<PropsWithChildren<IamNavigationRailItemsPropsType>> = (props) => {

    const routeParams = useParams<{ projectId: string }>();
    const iamPermissions = routeParams.projectId ? props.authUser.hasIamRoleForProject(routeParams.projectId) : null;
    const route = routeParams.projectId !== undefined ? `/projects/${mapPublisherProjectIdToProjectIdString(routeParams.projectId)}/users` : '#';

    const [active, setActive] = React.useState<boolean>(window.location.pathname === route);

    useEffect(() => {
        setActive(window.location.pathname === route);
    }, [window.location.pathname]);

    const adjustRoute = () => props.hostedInPortal ? route : (props.portalUrl + route);

    if (!iamPermissions || !iamPermissions.roles || iamPermissions.roles?.length === 0)
        return null;

    return <NavLink as="a"
                    className={`${styles.navigationRailNavItem} text-capitalize navigationRailNavItem`}
                    active={active}
                    href={adjustRoute()}><i className="fas fa-user-shield" /><span>Users</span></NavLink>;

};

